import EFPicture from 'elem/compCommon/EFPicture';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper';
import { useGlobal } from '@/utils/useGlobal';

export default function K() {
    const { useLang, useRouter } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('solar_panel_160w_single');
    // const [active, setActive] = useState(0);
    // const [swiper, setSwiper] = useState(null);

    const arr = [
        {
            img: '/responsive/picture/solar-panel-160w-single/10_1_768.jpg',
        },
        {
            img:
                locale === 'mx'
                    ? 'https://websiteoss.ecoflow.com/upload/image/1747101993994/220_M_2.jpg'
                    : locale === 'br'
                    ? 'https://websiteoss.ecoflow.com/upload/image/1742974700440/IP68.png'
                    : `/responsive/picture/solar-panel-160w-single/10_2_768_${['jp'].includes(locale) ? locale : 'us'}.jpg`,
        },
    ];

    return (
        <div className="sp-160-single-K">
            <div className="info-box">
                <p className="title">{t('K_title')}</p>
                <p className="desc">{t('K_desc')}</p>
            </div>
            <div className="img-box pc">
                <EFPicture
                    src={
                        locale === 'mx'
                            ? 'https://websiteoss.ecoflow.com/upload/image/1747033620923/220w.jpg'
                            : locale === 'br'
                            ? 'https://websiteoss.ecoflow.com/upload/image/1742365191956/220w.png'
                            : `/responsive/picture/solar-panel-160w-single/10_${['jp'].includes(locale) ? locale : 'us'}.jpg`
                    }
                    alt={t('K_title')}
                />
            </div>
            <Swiper
                className={`swiper-box h5`}
                modules={[Pagination]}
                spaceBetween={0}
                slidesPerView={'auto'}
                initialSlide={0}
                pagination={true}
                // onSlideChange={(swiper) => setActive(swiper?.activeIndex || 0)}
                // onSwiper={(swiperIns: any) => setSwiper(swiperIns)}
            >
                {arr?.map((item: any, k: number) => (
                    <SwiperSlide className="swiper-item" key={k}>
                        <EFPicture src={item.img} alt={t('K_title')} />
                    </SwiperSlide>
                ))}
            </Swiper>
        </div>
    );
}
